<template>
  <b-progress class="al-progress" test-id="al-progress">
    <b-progress-bar ref="al-progress-bar" :value="value" :variant="variant">
      <slot />
    </b-progress-bar>
  </b-progress>
</template>

<script>
import { BProgress, BProgressBar } from 'bootstrap-vue';

export default {
  components: {
    BProgress,
    BProgressBar
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    variant: {
      type: String,
      default: 'success'
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Variables
 */
$height: 4px;
$bg-color: #d9e3e2;
$bg-success-color: #5be3b5;
$br-radius: 3.5px;

.al-progress {
  background-color: $bg-color;
  border-radius: $br-radius;
  height: $height;

  .progress-bar {
    &.bg-success {
      background-color: $bg-success-color !important;
    }
  }
}
</style>
